import { useState } from "react"
import PropTypes from "prop-types"

import StripeJsContainer from "../stripe_js_container"
import CheckoutForm from "shared/components/stripe/checkout_form"

import {
  trackPaymentMethodUpdateStarted,
  trackPaymentMethodUpdateCompleted,
  trackPaymentMethodUpdateFailed,
} from "app/utils/mixpanel_tracking"

export default function UpdatePaymentInfo(props) {
  const [lastPaymentMethodType, setLastPaymentMethodType] = useState("card")
  const entrypoint = "billing_payment_method_update"

  const onCreateSubscriptionStart = paymentMethodType => {
    setLastPaymentMethodType(paymentMethodType)

    trackPaymentMethodUpdateStarted({
      paymentMethodType,
      requiresAction: false,
      entrypoint,
    })
  }

  const onCreateSubscriptionCancel = error => {
    trackPaymentMethodUpdateFailed({
      paymentMethodType: lastPaymentMethodType,
      requiresAction: false,
      entrypoint,
      errorType: error?.message || "payment_method_update_cancelled",
    })
  }

  const buttonConfig = {
    buttonType: "",
    cta: "Update payment",
    submittingCopy: "Updating...",
  }

  const processedAfterPaymentMethodSetup = async (paymentMethod, checkoutFormReset) => {
    await fetch(props.updatePaymentUrl, {
      method: "post",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "X-CSRF-Token": window.App.authenticityToken,
      },
      body: JSON.stringify({
        payment_method: paymentMethod,
      }),
    })
      .then(result => {
        return result.json()
      })
      .then(result => {
        const requiresAction = !!result.requires_action

        if (result.redirect_to) {
          trackPaymentMethodUpdateCompleted({
            paymentMethodType: lastPaymentMethodType,
            requiresAction,
            entrypoint,
          })

          window.appendFlash("Payment info updated!", "success")
          window.location.assign(result.redirect_to)
        } else {
          trackPaymentMethodUpdateFailed({
            paymentMethodType: lastPaymentMethodType,
            requiresAction,
            entrypoint,
            errorType: result.error || "payment_method_update_failed",
          })

          window.appendFlash("Payment info failed. Please contact us to get help.", "danger")
          checkoutFormReset()
          window.App.loadZendeskMessenger()
        }
      })
      .catch(response => {
        trackPaymentMethodUpdateFailed({
          paymentMethodType: lastPaymentMethodType,
          requiresAction: false,
          entrypoint,
          errorType: response?.message || "payment_method_update_network_error",
        })
        window.appendFlash("Payment info failed. Please contact us to get help.", "danger")
        checkoutFormReset()
        window.App.loadZendeskMessenger()
      })
  }

  return (
    <StripeJsContainer selectedPrice={props.currentPrice} email={props.userEmail}>
      <CheckoutForm
        buttonConfig={buttonConfig}
        email={props.userEmail}
          onCreateSubscriptionCancel={onCreateSubscriptionCancel}
          onCreateSubscriptionStart={onCreateSubscriptionStart}
        processedAfterPaymentMethodSetup={processedAfterPaymentMethodSetup}
        promoCodeConfig={null}
      />
    </StripeJsContainer>
  )
}

UpdatePaymentInfo.propTypes = {
  currentPrice: PropTypes.number.isRequired,
  userEmail: PropTypes.string.isRequired,
  updatePaymentUrl: PropTypes.string.isRequired,
}
